import { ComputerWithAccessRepository } from "@/api/Repositories";

export default {
  namespaced: true,
  state: {
    computers: []
  },
  mutations: {
    getComputers (state, computers) {
      state.computers = []
      state.computers = computers
    }
  },
  actions: {
    // Get
    getComputers ({ commit }, obj) {
      return new Promise((resolve, reject) => {
        ComputerWithAccessRepository.getAll(obj)
          .then(response => {
            const computers = response.data.data.reverse()
            commit('getComputers', computers)
            resolve();
          })
          .catch(error => {
            reject(error);
          })
      })
    },
    // Actions    
    createComputer (context, computer) {
      return new Promise((resolve, reject) => {
        ComputerWithAccessRepository.create(computer)
          .then(() => {
            resolve();
          })
          .catch(errorCreate => {
            reject(errorCreate);
          });
      });
    },
    editComputer (context, computer) {
      return new Promise((resolve, reject) => {
        ComputerWithAccessRepository.update(computer)
          .then(() => {
            resolve();
          }).catch(errorEdit => {
            reject(errorEdit);
          });
      });
    },
    deleteComputer (context, id) {
      return new Promise((resolve, reject) => {
        ComputerWithAccessRepository.delete(id)
          .then(() => {
            resolve();
          })
          .catch(errorDelete => {
            reject(errorDelete);
          });
      });
    }
  }
}
